import { render } from "./ProcessMasterListA.vue?vue&type=template&id=1ffe4b26"
import script from "./ProcessMasterListA.vue?vue&type=script&lang=js"
export * from "./ProcessMasterListA.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__